import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO. Replaces (not appends) title/description/canonical/og via react-helmet-async.
 * Accepts an optional `jsonLd` array of plain objects to inject as <script type="application/ld+json">.
 */
export default function SEO({
  title,
  description,
  canonical,
  keywords,
  image,
  ogType = "website",
  jsonLd = [],
}) {
  return (
    <Helmet prioritizeSeoTags>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="Carroattrezzi Roma H24" />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:alt" content="Carroattrezzi Roma H24 - intervento notturno" />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}

      {/* JSON-LD */}
      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
